import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { HiDownload } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import CompanyVideo from "../sections/company-video";

const MediaCenter = () => {
  const { data, isLoading, isError } = useQuery(["medias"], async () => {
    const response = await window.fetch(`${BASE_URL}/media-center`);
    return await response.json();
  });

  const location = useLocation();
  const [pageNumber, setPageNumber] = useState(1);

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <Helmet>
        <title>AFRO || Media Center</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={"image"}
        imageURL={data?.mediaCenter?.media_center_banner?.image}
      >
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            {data?.mediaCenter?.media_center_banner?.title}
          </h1>
        </div>
      </Header>
      <section className="container-fluid pt-7 pb-7">
        <section className="ms-47 me-47">
          <section>
            <div className="d-flex justify-content-between bg-ghost-white px-5 py-4">
              <Link
                to="/media-center?year=2021"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                2021
              </Link>
              <Link
                to="/media-center?year=2020"
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                2020
              </Link>
              <Link
                to=""
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                2019
              </Link>
              <Link
                to=""
                className="fs-16 text-decoration-none text-orange-ryb d-block gilroy-bold"
              >
                2018
              </Link>
            </div>
            <div>
              {data?.mediaCenter?.media?.map((mediaInfo, index) => (
                <div key={index} className="row mt-4 py-5 px-4">
                  <div className="col-2">
                    <time className="fs-14 gilroy-bold">{mediaInfo?.date}</time>
                  </div>
                  <div className="col-8">
                    <h2 className="fs-16">{mediaInfo?.title}</h2>
                  </div>
                  <div className="col-2">
                    <a
                      href={mediaInfo?.button_link}
                      target="_blank"
                      rel="noreferrer"
                      className="fs-16 gilroy-bold text-orange-ryb text-decoration-none"
                    >
                      {mediaInfo?.button_text}
                    </a>
                  </div>
                  <hr className="mt-3" />
                </div>
              ))}
            </div>
            <div className="text-center py-5 bg-ghost-white">
              <Link
                to="/media-center?page=1"
                className="fs-16 text-decoration-none gilroy-bold d-inline-block mx-3"
                style={{
                  backgroundColor: "#f49807",
                  color: "#ffffff",
                  padding: "0.5rem",
                  borderRadius: "2rem",
                  width: "3.5%",
                }}
              >
                {pageNumber}
              </Link>
            </div>
          </section>
          <section className="my-5">
            <h2 className="fs-26 gilroy-bold my-5 pt-5">Media Library</h2>
            <div className="row g-5">
              {data?.mediaCenter?.media_center_library?.map((media, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4">
                  <div style={{ height: "200px" }}>
                    <img
                      src={`${IMAGE_BASE_URL}/${media?.image}`}
                      alt={media?.title || ""}
                      className=" d-block img-fluid rounded"
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        objectPosition: "50% 50%",
                      }}
                    />
                  </div>
                  <a
                    href={`${BASE_URL}/media-library-downolad/${media?.id}`}
                    download
                    className="text-decoration-none fs-14 gilroy-bold text-orange-ryb mt-2 d-block"
                  >
                    <HiDownload className="text-success" /> Download
                  </a>
                </div>
              ))}
            </div>
          </section>
          <CompanyVideo
            companyVideos={data?.mediaCenter?.media_center_video_library}
          />
          {/* <section className="pt-7">
            <h3 className="fs-28 gilroy-bold">Media Contact</h3>
            <div>
              <h4 className="fs-18 gilroy-bold my-4">Afro Towers plc</h4>
              <p className="fs-16">10th floor</p>
              <p className="fs-16">5 Merchant Square West</p>
              <p className="fs-16">London W2 1AS</p>
              <p className="fs-16">United Kingdom</p>
              <p className="fs-16">T: +44 (0) 207 871 3670</p>
              <p className="fs-16">F: +44 (0) 207 235 6542</p>
            </div>
            <div>
              <h4 className="fs-18 gilroy-bold my-4">Media Relations</h4>
              <p className="fs-16">Edward Bridges</p>
              <p className="fs-16">FTI Consulting</p>
              <p className="fs-16">+44 (0)20 3727 1000</p>
            </div>
          </section> */}
        </section>
      </section>
      <Footer />
    </>
  );
};

export default MediaCenter;
